import Bugsnag from '@bugsnag/js';

const modeStrengthMap = {
  '-1': {
    label: 'Original',
  },
  0: {
    label: 'Fluency',
  },
  1: {
    label: 'Concision',
  },
  2: {
    label: 'Standard',
    description: '',
  },
  3: { label: 'Suggestive' },
  6: { label: 'Creative' },
  7: { label: 'Shorten' },
  8: { label: 'Expand' },
  9: { label: 'Formal' },
  10: { label: 'Simple' },
};

export const getModeLabel = strength => {
  if (typeof modeStrengthMap[strength] !== 'object') {
    Bugsnag.notify({
      name: 'MODE_NOT_FOUND',
      message: `No label found for Mode: ${strength}`,
    });
  }
  return modeStrengthMap[strength]?.label;
};
